var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Win" }, [
    _c("div", { staticClass: "Winmain" }, [
      _c("div", { staticClass: "header" }, [
        _c("b", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
        _c("i", {
          staticClass: "iconfont icon-guanbi-1",
          on: { click: _vm.close }
        })
      ]),
      _vm._v(" "),
      _vm.ind === 0
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("300171")))]),
              _vm._v(" "),
              _vm.userList.length > 0
                ? _c("div", [
                    _c("p", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("300085")))]),
                      _c("span", [_vm._v(_vm._s(_vm.$t("300131")))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "winuser" }, [
                      _c(
                        "div",
                        _vm._l(_vm.userList, function(item, index) {
                          return _c("p", { key: index }, [
                            _c("span", [_vm._v(_vm._s(item.account))]),
                            _c("span", [_vm._v("500 ET")])
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                : _c(
                    "van-empty",
                    {
                      staticClass: "custom-image",
                      attrs: { description: _vm.$t("300108") }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "icon",
                          attrs: { slot: "image", "aria-hidden": "true" },
                          slot: "image"
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-zanwujilu" }
                          })
                        ]
                      )
                    ]
                  )
            ],
            1
          )
        : _c("div", {
            staticClass: "content",
            domProps: { innerHTML: _vm._s(_vm.content) }
          }),
      _vm._v(" "),
      _c("div", { staticClass: "Btn" }, [
        _c("span", { on: { click: _vm.close } }, [
          _vm._v(_vm._s(_vm.$t("300141")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19901abc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19901abc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/dialog.vue
// module id = 1OsD
// module chunks = 0